import Select, { SelectOption, SelectOptions } from "./Select";

export { SelectOption, SelectOptions };
export default Select;
